import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MonitoringImage } from '../../../cctv-monitoring/cctv-monitoring.models';
import { MapVehicle } from '../../cctv-monitoring-map.models';

type CameraCategory = 'cabin' | 'outside' | 'event';

@Component({
  selector: 'app-map-image-dialog',
  templateUrl: './map-image-dialog.component.html',
  styleUrls: ['./map-image-dialog.component.css'],
})
export class MapImageDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() vehicle!: MapVehicle;
  @Input() images: MonitoringImage[] = [];
  @Input() category: CameraCategory = 'cabin';
  @Input() statusLabel = 'نامشخص';
  @Output() readonly close = new EventEmitter<void>();
  @Output() readonly zoomVehicle = new EventEmitter<void>();
  imageFailed = false;
  private previousFocus: HTMLElement | null = null;

  ngOnInit(): void {
    this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  }

  ngAfterViewInit(): void {
    document.getElementById('map-image-dialog-close')?.focus();
  }

  ngOnDestroy(): void {
    this.previousFocus?.focus();
  }

  get currentImage(): MonitoringImage | undefined {
    return this.images.find(image => image.unitId === this.vehicle.strUnitID && image.category === this.category);
  }

  selectCategory(category: CameraCategory): void {
    this.category = category;
    this.imageFailed = false;
  }

  get positionTime(): string {
    return [this.vehicle.strDate, this.vehicle.strTime].filter(Boolean).join(' ') || this.vehicle.strTimeAge || 'نامشخص';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { this.close.emit(); }

  @HostListener('document:keydown.tab', ['$event'])
  onTab(event: KeyboardEvent): void {
    const controls = Array.from(document.querySelectorAll<HTMLElement>('.map-image-dialog button:not([disabled])'));
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
